import { Colors, Language, Lightning, Router, Utils, Log } from '@lightningjs/sdk'
import { appSettings } from '../../lib/AppSettings'
import MenuList from './MenuList'
import nowPlaying from './nowPlaying'

export default class SideMenu extends Lightning.Component {
  static _template() {
    return {
      MenuWrapper: {
        w: 160,
        h: 1080,
        rect: true,
        zIndex: 110,
        color: Colors('white').get(),
        clipping: true,
        LogoL: { x: 85, y: 62, w: 74, h: 74, src: Utils.asset('images/menu/mnuLogoL.png') },
        LogoR: {
          w: 250,
          h: 74,
          x: 160,
          y: 62,
          src: Utils.asset('images/menu/mnuLogoR.png'),
          alpha: 0,
        },
        MenuList: {
          type: MenuList,
          w: 160,
          h: 800,
          y: 270,
          zIndex: 10,
          spacing: 0,
          signals: { indexChanged: true },
        },
        SelectBar: {
          w: 10,
          h: 90,
          x: 150,
          y: 270,
          zIndex: 10,
          rect: true,
          color: Colors('lBlue').get(),
        },
        NowPlaying: {
          w: 160,
          h: 40,
          y: 930,
          zIndex: 10,
          type: nowPlaying,
        },
      },
      // BG: {w: 800, h: 1080, x: -800, rect: true, zIndex: 100, colorLeft: Colors("MenuOverlay").get(), colorRight: Colors("MenuOverlay").alpha(0).get()}
    }
  }

  _init() {
    this._index = 0
    this._activeIndex = 0
    this._menuReady = false

    this.tag('MenuList').menuItems = [
      { key: 'radio', label: Language.translate('MenuRadio'), route: 'radio', icon: 'mnuRadio' },
      {
        key: 'catchup',
        label: Language.translate('MenuCatchup'),
        route: 'catchup',
        icon: 'mnuCatchup',
      },
      {
        key: 'playlists',
        label: Language.translate('MenuPlaylists'),
        route: 'playlists',
        icon: 'mnuPlaylists',
      },
      {
        key: 'podcasts',
        label: Language.translate('MenuPodcasts'),
        route: 'podcasts',
        icon: 'mnuPodcast',
      },
      {
        key: 'settings',
        label: Language.translate('MenuSettings'),
        route: 'settings',
        icon: 'mnuSettings',
      },
    ]

    this._setState('Idle')
  }

  get activeItem() {
    return this.tag('MenuList').currentItem
  }

  get selectedItem() {
    return this.tag('MenuList').items[this._activeIndex]
  }
  radioMessageNowPlaying() {
    this.tag('NowPlaying').radioMessageNowPlaying()
  }
  OnGpStateChange({ state, playbuttonState }) {
    this.tag('NowPlaying').OnGpStateChange({ state, playbuttonState })
  }

  set activeMenuItem(idx) {
    this._index = idx
    this._activeIndex = idx

    this.tag('MenuList').index = idx

    if (this.tag('SelectBar') && this.tag('MenuList') && this.tag('MenuList').currentItem) {
      this.tag('SelectBar').setSmooth('y', this.tag('MenuList').currentItem.y + 270, {
        delay: 0.1,
        duration: 0.3,
      })
    }
  }

  _focus() {
    this._setState('MenuList')
  }

  _unfocus() {
    this._setState('Idle')
  }

  _showHideMenu(show) {
    const duration = show === true ? 0.4 : 0.3,
      delay = show === true ? 0.1 : 0.2,
      menuW = show === true ? 465 : 160,
      logoAlpha = show === true ? 1 : 0,
      barX = show === true ? 455 : 150
    // bgX = show === true ? 465 : -800;

    this.patch({
      MenuWrapper: {
        smooth: { w: [menuW, { delay: delay, duration: duration }] },
        LogoR: { smooth: { alpha: [logoAlpha, { delay: delay, duration: duration }] } },
        SelectBar: { smooth: { x: [barX, { delay: delay, duration: duration }] } },
      },
      // "BG": {smooth: {"x": [bgX, {delay: delay, duration: duration}]}}
    })
  }

  static _states() {
    return [
      class Idle extends this {},

      class MenuList extends this {
        $enter() {
          this._showHideMenu(true)
        }

        $exit() {
          this._showHideMenu(false)
        }

        _handleRight() {
          Router.restoreFocus()
        }
        _handleBack() {
          Log.info('SideMenu:HandleBack')
          //if (Router.getActiveHash() === 'radio') {
          //  this.application.closeApp()
          //} else {
          return false
          //}
        }

        _handleEnter() {
          appSettings.catchUpBackState = {}

          this.activeMenuItem = this.tag('MenuList').index
          if (Router.getActiveHash() === this.tag('MenuList').currentMenuItem.route) {
            Router.restoreFocus()
          } else {
            Router.navigate(this.tag('MenuList').currentMenuItem.route)
          }
        }

        _handleDown() {
          if (this.tag('NowPlaying').isPlaying) this._setState('MenuList.nowPlaying')
        }

        _getFocused() {
          return this.tag('MenuList')
        }
        static _states() {
          return [
            class nowPlaying extends MenuList {
              _handleUp() {
                this._setState('MenuList')
              }
              _getFocused() {
                return this.tag('NowPlaying')
              }
            },
          ]
        }
      },
    ]
  }
}
